import { Modal, Button } from "antd";
import { deleteFleetModelApi } from "api/fleetModel";
import WarningIcon from "components/Icons/WarningIcon";
import { RouteName } from "constants/route";
import { useNotificationContext } from "contexts/NotificationContext";
import { IFleetModel } from "models/fleetModel";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface IProp {
  open: boolean;
  fleetModel: IFleetModel;
  handleClose: () => void;
}

export default function DeleteModal({ open, fleetModel, handleClose }: IProp) {
  const [loading, setLoading] = useState<boolean>(false);
  const { showError, showSuccess } = useNotificationContext();
  const navigate = useNavigate();

  const handleBan = async () => {
    setLoading(true);
    const { data, error } = await deleteFleetModelApi(fleetModel.id);
    if (data) {
      showSuccess("FleetModel deleted successfully");
      navigate(RouteName.FLEET_MODEL, { replace: true });
    } else showError(error!.message);
    setLoading(false);
    handleClose();
  };

  return (
    <Modal open={open} title={null} footer={null} closeIcon={null} centered>
      <div className="w-full text-center">
        <div className="w-full text-orange-400 text-9xl flex justify-center my-6">
          <WarningIcon />
        </div>
        <h3 className="text-3xl font-semibold my-4">Are you sure?</h3>
        <p
          className="font-normal text-base"
          style={{ color: "rgba(0,0,0,.64)" }}
        >
          You're about to delete {fleetModel.name}
        </p>
        <div className="w-full flex mt-7 items-center justify-end gap-x-3">
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleBan} loading={loading} type="primary" danger>
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
}
